import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'previousWeekUsageCategory'
})
export class PreviousWeekUsageCategoryPipe implements PipeTransform {
  transform(previousWeekUsage: number) {
    if (previousWeekUsage < 30) {
      return 'red';
    } else if (previousWeekUsage < 60) {
      return 'yellow';
    } else if (previousWeekUsage < 150) {
      return 'green';
    }
    return 'purple';
  }
}
